export interface UserContactDetails {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  postcode?: string;
  address1?: string;
  address2?: string;
}

/**
 * Generates a mailto link with prepopulated user details for signup help
 */
export function generateSignupHelpMailto(userDetails: UserContactDetails): string {
  const subject = encodeURIComponent("Help signing up to KatKin");

  const fullName = [ userDetails.firstName, userDetails.lastName ].filter(Boolean).join(" ");
  const details = [
    [ "Name", fullName ],
    [ "Email", userDetails.email ],
    [ "Phone", userDetails.phone ],
    [ "Postcode", userDetails.postcode ],
    [ "Address1", userDetails.address1 ],
    [ "Address2", userDetails.address2 ],
  ]
    .filter(([ _, value ]) => value)
    .map(([ label, value ]) => `${label}: ${value}`)
    .join("\n");

  const body = `Hi there!\n\nI'd love some help signing up to KatKin.\n\nMy details:\n${details}\n\nThank you!`;

  return `mailto:meow@katkin.com?subject=${subject}&body=${encodeURIComponent(body)}`;
}
